const config = [{ columns: 3 }, { columns: 3 }, { columns: 6, size: 'medium' }];

export default config;
